type BBRenderedContent = {
  html: string;
  markup: 'markdown' | 'creole';
  raw: string;
  type: 'rendered';
};

declare global {
  namespace BB {
    type RenderedContent = BBRenderedContent;
  }
}

export type RenderedContent = BBRenderedContent;
